import React from 'react';
import { reduxForm } from 'redux-form';
import VeridQuestion from './VeridQuestion/veridQuestion';
import PropTypes from 'prop-types';
import './veridForm.scss';

export const VeridForm = (props) => {
  const { questions, handleSubmit, submitting, invalid } = props;
  return (
    <form autoComplete="off" noValidate="novalidate" onSubmit={handleSubmit} className="verid-form">
      {questions.map(question => (
        <VeridQuestion key={question.id} question={question} />
      ))}
      <div className="container">
        <div className="row">
          <div className="col">
            <button type="submit" disabled={submitting || invalid}>
              Continue
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

VeridForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      helpText: PropTypes.string,
      choices: PropTypes.arrayOf(PropTypes.shape({
        choiceId: PropTypes.string,
        text: PropTypes.string
      }))
    }).isRequired
  ).isRequired
};

export default reduxForm({
  form: 'verid'
})(VeridForm);
